import { ValidationIcon_default } from "./chunk-LZGR2HFH.js";
import { InputComponent } from "./chunk-OADWJROU.js";
import { TransitionComponent } from "./chunk-3HAR27K6.js";
import { Spinner_default } from "./chunk-6KCFYSFL.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Listbox/Listbox.tsx
import React, { forwardRef, useMemo, Children, Fragment } from "react";
import clsx from "clsx";
import { Listbox as HeadlessListbox } from "@headlessui/react";
var Listbox = forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      name,
      value,
      defaultValue,
      onChange,
      disabled,
      validation,
      placeholder,
      isLoading,
      className
    } = _b,
    rest = __objRest(_b, ["children", "name", "value", "defaultValue", "onChange", "disabled", "validation", "placeholder", "isLoading", "className"]);
  const selectedLabel = useMemo(() => {
    const childrenArray = Children.toArray(children);
    const labelChild = childrenArray.find(child => child.props.value === value);
    return (labelChild == null ? void 0 : labelChild.props.children) ? labelChild.props.children : "";
  }, [children, value]);
  return /* @__PURE__ */React.createElement(HeadlessListbox, {
    as: "div",
    name,
    value,
    defaultValue,
    onChange,
    disabled,
    className: clsx("pd-listbox-wrapper", className)
  }, /* @__PURE__ */React.createElement(InputComponent, {
    validation,
    disabled,
    className: clsx("pd-listbox", !selectedLabel && placeholder && "pd-listbox--placeholder", isLoading && "pd-listbox--loading", validation && "pd-listbox--validation")
  }, /* @__PURE__ */React.createElement(InputComponent.Input, __spreadProps(__spreadValues({
    ref,
    as: HeadlessListbox.Button
  }, rest), {
    isLoading,
    "aria-placeholder": placeholder,
    className: "pd-listbox__input"
  }), selectedLabel || placeholder), validation && !isLoading && /* @__PURE__ */React.createElement(InputComponent.Icon, null, /* @__PURE__ */React.createElement(ValidationIcon_default, {
    variant: validation
  })), isLoading && /* @__PURE__ */React.createElement(InputComponent.Icon, null, /* @__PURE__ */React.createElement(Spinner_default, {
    variant: "primary"
  }))), /* @__PURE__ */React.createElement(TransitionComponent, {
    variant: "appear-from-top",
    as: Fragment
  }, /* @__PURE__ */React.createElement(HeadlessListbox.Options, {
    static: true,
    className: "pd-listbox-options"
  }, children)));
});
var Listbox_default = Listbox;
export { Listbox_default };